<ng-container *ngIf="profile">
  <span class="user-name"
    >{{ profile.first_name }} {{ profile.last_name }}</span
  >
</ng-container>
